import { Component, Injectable } from '@angular/core';
import { User } from '@models/identity/user';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { UsersService } from '@services/entity/users.service';
import { plainToClass } from 'class-transformer';
//import * as customerConfig from '@assets/config/roles/config.customer.json';
//import * as operatorConfig from '@assets/config/roles/config.operator.json';
import { FilesService } from '@services/files/files.service';

@Injectable({
  providedIn: 'any'
})
export class ConfigurationService {

  constructor(private usersService: UsersService, private filesService: FilesService) { }

  public async getConfiguration(componentName: string, roles: string[]) {
    if (roles.includes('Operator') && this.filesService.operatorConfig) {
      return this.filesService.operatorConfig[componentName];
    }
    if (roles.includes('Customer') && this.filesService.customerConfig) {
      return this.filesService.customerConfig[componentName];
    }
    if (roles.includes('User') && this.filesService.userConfig) {
      return this.filesService.userConfig[componentName];
    }
    if (roles.includes('Technical') && this.filesService.technicalConfig) {
      return this.filesService.technicalConfig[componentName];
    }
    if (roles.includes('Account') && this.filesService.accountConfig) {
      return this.filesService.accountConfig[componentName];
    }
  }
}
